import { useEffect, useState } from "react";
export const isKybApprovalRequired = ({
  kyb_approval_required,
  kyb_approval_status,
}) => {
  return kyb_approval_required === 1 && kyb_approval_status !== 1
    ? true
    : false;
};

export function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    // Update debounced value after delay
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    // Cancel the timeout if value changes (also on delay change or unmount)
    // This is how we prevent debounced value from updating if value is changed ...
    // .. within the delay period. Timeout gets cleared and restarted.
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}

export function findIfProductIsAlreadySelected(category, product) {
  if (category.selected) {
    if (!category.products.length) {
      return true;
    } else if (
      category.products.indexOf(product) != -1 ||
      category.products.indexOf(product.toString()) != -1
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    if (!category.products.length) {
      return false;
    } else if (
      category.products.indexOf(product) != -1 ||
      category.products.indexOf(product.toString()) != -1
    ) {
      return false;
    } else {
      return true;
    }
  }
}

export const CAMPAIGN_NAME_VALIDATION_REGEX =
  /^(?![\s-])[a-zA-Z0-9_\s-]{0,40}$/;

export const COUNTRY_NAME_VALIDATION_REGEX = /^(?![\s-])[a-zA-Z_\s-]{0,75}$/;
